export default __webpack_public_path__ + "static/media/arrow.4b2f5f39.svg";